<script>
  import { client } from './lib/client';
  import { createQuery } from '@tanstack/svelte-query';
  import CuratedByCreatorPage from './CuratedByCreatorPage.svelte';
  import { _ } from 'svelte-i18n';

  async function configPreview() {
    // eslint-disable-next-line
    const { search } = location;
    const result = await client.get(`/preview${search}`);
    return result.data.object;
  }

  $: previewPageQuery = createQuery({
    queryKey: ['creator-preview'],
    queryFn: () => configPreview(),
  });
</script>

{#if $previewPageQuery.isLoading}
  <div class="flex h-[100vh] w-[100vw] items-center justify-center">
    <p>
      {$_('curatedby.page.loading', {
        default: 'loading...',
      })}
    </p>
  </div>
{:else if $previewPageQuery.data}
  <div class="no-scrollbar bg-white">
    <CuratedByCreatorPage
      previewMode={true}
      handle={$previewPageQuery.data.handle || ''}
      profileImageUrl={$previewPageQuery.data.imageUrl}
      bioLine1={$previewPageQuery.data.bioLine1 || ''}
      bioLine2={$previewPageQuery.data.bioLine2 || ''}
      recentLinks={$previewPageQuery.data.recentLinks}
      topLinks={$previewPageQuery.data.topLinks}
    />
  </div>
{:else if $previewPageQuery.error}
  <div class="flex h-[100vh] w-[100vw] items-center justify-center">
    <p>
      {$_('curatedby.page.unexpectedError', {
        default: 'Unexpected Error',
      })}
    </p>
  </div>
{/if}

<style>
  :global(html) {
    scrollbar-width: none;
  }
</style>
